<NavBar screenTitle="Settings"/>
<div class='columns is-marginless'>
    <div class='column is-half'>
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Game Parameters
            </div>
            <div class='panel-block'>
                <div class='is-full-width'>
                    <div class='field'>
                        <label>Number of innings</label>
                        <div class='control'>
                            <div class='select is-primary'>
                                <select bind:value=$innings>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="9">9</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class='panel-block'>
                <div class='is-full-width'>
                    <div class="field">
                        <input bind:checked=$hasExtraFielder id="twoCenterfielders" type="checkbox" name="twoCenterfielders" class="switch">
                        <label for="twoCenterfielders">Use 2 center fielders (10 fielders)</label>
                    </div>
                </div>
            </div>
        </nav>
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Display
            </div>
            <div class='panel-block'>
                <div class='is-full-width'>
                    <div class="field">
                        <input id="showAllPlayersSitting" type="checkbox" name="showAllPlayersSitting" class="switch" checked="">
                        <label for="showAllPlayersSitting">Show all players sitting status</label>
                    </div>
                </div>
            </div>
        </nav>
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Configuration
            </div>
            <div class='panel-block'>
                <div class='is-full-width'>
                    <div class="field">
                        <input bind:checked=$useDepthChartToFill id="useDepthChartFilling" type="checkbox" name="useDepthChartFilling" class="switch" checked="">
                        <label for="useDepthChartFilling">Use depth chart for filling lineups</label>
                    </div>
                </div>
            </div>
        </nav>
    </div>
    <div class='column is-half'>
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Warnings
            </div>
            <div class='panel-block'>
                <div class='is-full-width'>
                    <div class="field">
                        <input bind:checked=$warnOutOfPosition id="warnOutOfPosition" type="checkbox" name="warnOutOfPosition" class="switch" checked="">
                        <label for="warnOutOfPosition">Player out of postion</label>
                    </div>
                </div>
            </div>
            <div class='panel-block'>
                <div class='is-full-width'>
                    <div class="field">
                        <input bind:checked=$warnDepthChartMismatch id="warnDepthChartMismatch" type="checkbox" name="warnDepthChartMismatch" class="switch" schecked="">
                        <label for="warnDepthChartMismatch">Better player available</label>
                    </div>
                </div>
            </div>
        </nav>
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Account ({$email})
            </div>       
            {#if $loggedIn}
                <div class='panel-block'>
                    <div class='field'>
                        <label>Team Name</label>
                        <div class='control'>
                            <input class='input' id="teamName" name="teamName" type='text' placeholder="" bind:value='$teamName'>
                        </div>
                    </div>
                </div>
                <div class='panel-block'><button class='button is-primary is-full-width' on:click="logout()">Logout</button></div>
            {/if}
        </nav>
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Version Info
            </div>       
            <div class='panel-block'>
                Version: {$buildHash}<br/>
                Build Date: {$buildDate}
            </div>
            <div class='panel-block'><button class='button is-primary is-full-width' on:click="restart()">Reload app</button></div>
        </nav>
    </div>
</div>

<script>
    import NavBar from './NavBar.html';

    export default {
        methods: {
            logout() {
                this.store.set({loggedIn: false, email: '', token: ''});
            },
            restart() {
                window.location.reload();
            }
        },
		components: {
            NavBar
		}
	};

</script>
